import Text from "components/Text";
import { FC, forwardRef, memo, useCallback } from "react";
import { BsFillCheckCircleFill, BsFillXCircleFill } from "react-icons/bs";
import { IoMdClose } from "react-icons/io";
import { WithStyle } from "utils/WithStyle";
import { removeToast } from "../ToastContainer/ToastStore";
import { ToastWrapper } from "./Toast.styled";
import { ToastProps } from "./types";

const Component: FC<ToastProps> = memo(
    forwardRef(({ text, type, id, timer = 3000 }, ref) => {
        const handleClose = useCallback(() => removeToast(id), [id]);

        return (
            <ToastWrapper ref={ref} type={type} timer={timer}>
                {type === "success" ? (
                    <BsFillCheckCircleFill color="green" />
                ) : (
                    <BsFillXCircleFill color="red" />
                )}
                <Text variant="body2" fontWeight="500">
                    {text}
                </Text>
                <IoMdClose id="close" onClick={handleClose} />
            </ToastWrapper>
        );
    })
);

export const Toast: FC<ToastProps> & WithStyle = Object.assign(Component, {
    Style: ToastWrapper,
});
